import { supabase } from "@/lib/supabase";

export const REPORT_REASONS = [
  { key: "spam", label: "Spam" },
  { key: "fake_event", label: "Fake event" },
  { key: "harassment", label: "Harassment" },
  { key: "inappropriate", label: "Inappropriate content" },
  { key: "scam", label: "Scam" },
  { key: "other", label: "Other" },
];

export async function submitReport({ reporterId, targetType, targetId, reason, details }) {
  if (!reporterId || !targetType || !targetId || !reason) {
    throw new Error("Missing fields.");
  }
  const { error } = await supabase.from("reports").insert({
    reporter_id: reporterId,
    target_type: targetType,
    target_id: targetId,
    reason,
    details: details?.trim() || null,
  });
  if (error) throw error;
  return true;
}
